import { lazyPipe, validateApiResponse, withApiErrorCapture } from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { campaignsApiPath } from './apiPath';

const RecruitmentCampaignCategoryItemSchema = z
  .object({
    categoryNo: z.string(),
    categoryName: z.string(),
  })
  .describe('RecruitmentCampaignCategoryItemSchema');

export type RecruitmentCampaignCategoryItem = z.infer<typeof RecruitmentCampaignCategoryItemSchema>;

const GetRecruitmentCampaignCategoriesResponseDataSchema = z.object({
  categories: z.array(RecruitmentCampaignCategoryItemSchema),
});

const GetRecruitmentCampaignCategoriesResponseSchema = createApiResponseSchema(
  GetRecruitmentCampaignCategoriesResponseDataSchema,
);

export type GetRecruitmentCampaignCategoriesResponse = z.infer<
  typeof GetRecruitmentCampaignCategoriesResponseSchema
>;

export const getRecruitmentCampaignCategories = withApiErrorCapture(
  lazyPipe(
    async (): Promise<GetRecruitmentCampaignCategoriesResponse> =>
      executeStandardRequest(async () => {
        const response = await privateHttpClient.get<GetRecruitmentCampaignCategoriesResponse>(
          urlJoin(campaignsApiPath.getRecruitmentCategories),
        );
        return response;
      }),
    validateApiResponse(GetRecruitmentCampaignCategoriesResponseSchema),
  ),
);
